// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3tiP7","title":"styles_title__1O3C9","statsChart":"styles_statsChart__3fVVM","chart":"styles_chart__2OYlA"};